import React, { Component, Fragment } from 'react';
import LocaleListItem from './LocaleListItem.js';
import { withLocales } from '../../Providers/LocalesProvider.js';

let LocaleListItemWithLocales = withLocales(LocaleListItem);

class LocaleList extends Component {
  constructor (props) {
    super(props);
  }
  
  render () {
    const that = this;

    const strings = this.props.locales.map(function (locale) {
      return (
        <LocaleListItemWithLocales 
          updater={that.props.updater} 
          duplicator={that.props.duplicator}
          deleter={that.props.deleter} 
          key={locale.props.key + '.table.item'} 
          locale={locale}
        />
      );
    });

    return (
      <Fragment>
        <div className="title">
          <span className="title-content">
            <h1>Current Locales</h1>
          </span>
        </div>
        <div className="content">
          <table className="table is-fullwidth is-hoverable is-striped is-scrollable" style={{tableLayout: 'fixed'}} >
            <thead>
              <tr>
                <th>Key</th>
                <th style={{width: '70%'}}>Name</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {strings}
            </tbody>
          </table>
        </div>
      </Fragment>
    );
  }
}

export default LocaleList;


// WEBPACK FOOTER //
// ./src/Components/Locale/LocaleList.js